<template>
  <div>
    <div class="toolbarContainer">
      <div>
        <div class="md-title">
          {{ local.nome }}
        </div>
        <div class="md-subheading">
          {{ local.descricao }}
        </div>
      </div>
      <div class="buttonContainer">
        <router-link
          :to="{ name: 'LocalDetalhe', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary">
            Gráficos
          </md-button>
        </router-link>
        <router-link
          v-if="canViewMapa()"
          :to="{ name: 'EquipamentoMapaIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary"> Mapa </md-button>
        </router-link>
        <router-link
          v-if="canView()"
          :to="{ name: 'ViewIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary">
            Dashboard
          </md-button>
        </router-link>

        <router-link
          v-if="canEta()"
          :to="{ name: 'EtaIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary"> ETA </md-button>
        </router-link>

        <md-menu md-align-trigger>
          <md-button md-menu-trigger class="noMargin md-raised md-primary">
            Auditoria
          </md-button>

          <md-menu-content>
            <md-menu-item
              @click="
                $router.push({
                  name: 'AuditoriaAcoes',
                  params: { localId: localId },
                })
              "
            >
              <span>Ações</span>
            </md-menu-item>

            <md-menu-item
              @click="
                $router.push({
                  name: 'AuditoriaNotificacoes',
                  params: { localId: localId },
                })
              "
            >
              <span>Notificações</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
        <router-link
          :to="{ name: 'PontoSigIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary"> Sig </md-button>
        </router-link>
        <router-link
          v-if="isAdmin()"
          :to="{ name: 'EpanetAdmin', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary">
            Epanet Admin
          </md-button>
        </router-link>
        <router-link
          v-if="canEpanet()"
          :to="{ name: 'EpanetHeatmapIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary">
            Flow SH-TR
          </md-button>
        </router-link>
        <router-link
          v-if="canNotificacoes()"
          :to="{ name: 'NotificacaoIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary">
            Notificações
          </md-button>
        </router-link>
        <router-link
          v-if="canCargos()"
          :to="{ name: 'PessoaIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary"> Pessoas </md-button>
        </router-link>

        <router-link
          v-if="isAdmin()"
          :to="{ name: 'SensorVirtualIndex', params: { localId: localId } }"
        >
          <md-button class="noMargin md-raised md-primary">
            Sensores Virtuais
          </md-button>
        </router-link>
      </div>
    </div>
    <md-divider />
    <dashboard-skeleton-card-list v-if="loading" />
    <div v-if="!loading">
      <div class="statisticContainer">
        <md-card class="statisticItem">
          <md-icon class="statisticIcon"> person </md-icon>
          <div class="alignCenter">
            <div class="md-subhead">Pessoas</div>
            <div class="md-title">
              {{ statistics.pessoas }}
            </div>
          </div>
        </md-card>
        <md-card class="statisticItem">
          <md-icon class="statisticIcon"> manage_accounts </md-icon>
          <div class="alignCenter">
            <div class="md-subhead">Cargos</div>
            <div class="md-title">
              {{ statistics.cargos }}
            </div>
          </div>
        </md-card>
        <md-card class="statisticItem">
          <md-icon class="statisticIcon"> notifications </md-icon>
          <div class="alignCenter">
            <div class="md-subhead">Notificações</div>
            <div class="md-title">
              {{ statistics.notificacoes }}
            </div>
          </div>
        </md-card>
        <md-card class="statisticItem">
          <md-icon class="statisticIcon"> memory </md-icon>
          <div class="alignCenter">
            <div class="md-subhead">Equipamentos</div>
            <div class="md-title">
              {{ statistics.equipamentos }}
            </div>
          </div>
        </md-card>
        <md-card
          v-for="sensor in sensoresToShow"
          :key="sensor"
          class="statisticItem"
        >
          <md-icon class="statisticIcon"> sensors </md-icon>
          <div class="alignCenter">
            <div class="md-subhead">Sensores de {{ sensor }}</div>
            <div class="md-title">
              {{ statistics.sensores[sensor] }}
            </div>
          </div>
        </md-card>
      </div>
      <div>
        <dashboard-equipamentos-travados :local-id="localId" />
      </div>
      <div class="row mr-1 mt-4">
        <div class="col-12 col-md-8">
          <dashboard-graphic-area
            v-if="!data.loading"
            :tipo="'Dados por Minuto'"
            :series="[data]"
          />
          <loading :loading.sync="data.loading" />
        </div>
        <ultimas-notificacoes-index
          class="col-12 col-md-4"
          :limit="5"
          :local-id="localId"
        />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardEquipamentosTravados from '@/components/dashboard/DashboardEquipamentosTravados.vue'
import DashboardGraphicArea from '@/components/dashboard/DashboardGraphicArea'
import DashboardSkeletonCardList from '@/components/dashboard/DashboardSkeletonCardList'
import UltimasNotificacoesIndex from '@/components/dashboard/UltimasNotificacoesIndex'
import Loading from '@/components/Loading.vue'
import auth from '@/utils/auth'
import http from '@/utils/http'

export default {
  name: 'DashboardIndex',
  components: {
    DashboardEquipamentosTravados,
    DashboardGraphicArea,
    DashboardSkeletonCardList,
    UltimasNotificacoesIndex,
    Loading,
  },
  data() {
    return {
      localId: null,
      local: {},
      statistics: {},
      data: {
        name: 'Valor',
        data: [],
        loading: true,
      },
      loading: true,
    }
  },
  computed: {
    sensoresToShow() {
      return window.innerWidth > 768
        ? Object.keys(this.statistics.sensores)
        : []
    },
  },
  async beforeMount() {
    this.localId = this.localId || this.$route.params.localId

    this.local = (await http.get(`local/${this.localId}`)).local

    this.statistics = await http.get(`local/${this.localId}/dashboard`)

    this.loading = false

    this.data.data = (
      await http.get(`local/${this.localId}/dados-minuto`)
    ).dados
    this.data.data.sort(function (x, y) {
      return x[0] - y[0]
    })

    this.data.loading = false
  },
  methods: {
    canEpanet: auth.canEpanet,
    isAdmin: auth.isAdmin,
    canCargos: auth.canCargos,
    canView: auth.canViewVisualizar,
    canViewMapa: auth.canViewMapa,
    canEta: auth.canEta,
    canNotificacoes: auth.canNotificacoes,
  },
}
</script>

<style lang="scss" scoped>
.noMargin {
  margin: 0;
}

.alignCenter {
  margin: auto 0;
}

.toolbarContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.buttonContainer {
  margin: 7px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.statisticContainer {
  margin-top: 7px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-gap: 7px;
}

.statisticItem {
  margin: 0;
  padding: 7px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 7px;
}

.statisticIcon {
  width: 30px;
  height: 30px;
  font-size: 30px !important;
}

@media (max-width: 1200px) {
  .statisticContainer {
    grid-template-columns: repeat(7, 1fr);
  }
}

@media (max-width: 1034px) {
  .statisticContainer {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (max-width: 868px) {
  .statisticContainer {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 702px) {
  .statisticContainer {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 554px) {
  .statisticContainer {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 422px) {
  .statisticContainer {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
